<template>
    <div class="dashboard-container" id="food-app">
      <div class="container">
        <div class="tableBar">
          <el-input
            v-model="input"
            placeholder="请输入用户名称"
            style="width: 250px"
            clearable
            @keyup.enter="handleQuery"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
              style="cursor: pointer"
              @click="init"
            ></i>
          </el-input>
  
          <el-button type="danger" @click="sousuo"> 搜索</el-button>
  
  
  
        </div>
  
  
  
        <el-table
          :data="tableData"
          stripe
          class="tableBox"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="25"
          ></el-table-column>
          <el-table-column
            prop="id"
            label="用户身份序号"
          ></el-table-column>
          <el-table-column
            prop="username"
            label="用户姓名"
          ></el-table-column>
          <el-table-column
            prop="password"
            label="用户密码"
          >
          </el-table-column>

          <el-table-column
            prop="phone"
            label="用户电话"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="160"
            align="center"
          >
            <template #default="scope">
              <!-- <el-button
                type="primary"
                size="small"
                style="margin-bottom: 10px;margin-left: 12px;"
                class="delBut non"
                @click="changeHandle(scope.row)"
                icon="el-icon-delete"
              >
                修改
              </el-button> -->
              <el-button
                type="danger"
                size="small"
                class="delBut non"
                @click="deleteHandle( scope.row)"
                icon="el-icon-delete"
              >
                删除账户信息
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pageList"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="counts"
          @size-change="handleSizeChange"
          v-model:current-page="page"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>

    


    </div>
  
  
  </template>
  
  <script>
  import axios from "axios";
  
  
  
  
  
  export default {
    name: 'Manage',
    data() {
      return {
        tableData: [],
        typeNameArr: [],
        pagesize:10,
        page:1,
        input: '',
        counts:0,
        dialogTableVisible:false,
        adminmsg:{
       id:'',
          dormitoryDong:'',
          floorNum:'',
          status:'',
          type:"",
          roomNum:""
        },
      }
    },
  
  
  
    mounted() {
      this.init()
    },
    methods: {
  
      init(){
        const params = {
          page: this.page,
          pagesize: this.pagesize,
          input: this.input ? this.input : undefined
        }
        axios.get('http://localhost:8090/admin/getAlluser',{
            params
          }
        )
          .then(response => {
            this.tableData=response.data.data.records
            this.counts=response.data.data.total
            // 请求成功时的处理逻辑
            console.log(this.tableData)
  
          })
          .catch(error => {
            // 请求失败时的处理逻辑
            console.error(error); // 输出错误信息
          });
      },
  
      //点击搜索执行方法即可
      sousuo(){
        this.init();
  
      },
  
  //打开修改窗口
  editadmin(data){
     this.adminmsg=data
        this.dialogTableVisible=!this.dialogTableVisible
      },
      quedingedit(data){
  this.$confirm('确认修改该读者信息, 是否继续?', '确定修改', {
    'confirmButtonText': '确定',
    'cancelButtonText': '取消',
  }).then(()=>{
    axios.post('http://localhost:8090/admin/changeReader',data)
      .then(response => {
        // 请求成功时的处理逻辑
        this.$message.success("修改成功！")
        this.dialogTableVisible=!this.dialogTableVisible
        this.init()
      })
      .catch(error => {
        // 请求失败时的处理逻辑
        console.error(error); // 输出错误信息
      });
  })
},




      addFoodtype(){
        console.log(666)
      },
      handleQuery(){
        console.log(666)
      },
  
  
      deleteHandle(data){
        this.$confirm('确认删除该用户消息, 是否继续?', '确定删除', {
          'confirmButtonText': '确定',
          'cancelButtonText': '取消',
        }).then(()=>{
          axios.get('http://localhost:8090/admin/changeUser?id='+data.id)
            .then(response => {
              // 请求成功时的处理逻辑
              this.$message.success("删除成功！")
              this.dialogTableVisible=false
              this.init();
            })
            .catch(error => {
              // 请求失败时的处理逻辑
              console.error(error); // 输出错误信息
            });
        })
      },
      // 全部操作
      handleSelectionChange (val){
        let checkArr = []
        val.forEach((n) => {
          checkArr.push(n.id)
        })
        this.checkList = checkArr
      },
      handleSizeChange (val) {
        this.pageSize = val
        this.init()
      },
      handleCurrentChange (val) {
        this.page = val
        this.init()
      }
  
    }
  }
  </script>
  
  <style lang="less" scoped>
  .manage {
    padding: 16px;
  }
  </style>
  